import CreateWindow from "./puzzles/puzzleWindow";
import { html, render } from "lit-html";
import { mobileOrNot } from "./helpers/mobileDetect";
import "./infoScreen.css";
import { iOSallowScroll } from "./helpers/iOSHacks";
import { pickText } from "./textcontents";
import { unsafeHTML } from "lit-html/directives/unsafe-html";

export let infoStatus = {
  disabled: false,
};


export const InfoScreen = () => {
  if (infoStatus.disabled) return null;

  const puzzleWindow = CreateWindow({
    blurred: true,
    info: true,
    removeContainer: true,
    exitCallback: () => {
  document.body.classList.remove("hideImages")
      return null;
    },
  })

  const markup = unsafeHTML(`
  <div class="info-container" style="height: 100%;">
    <div class="info-screen">
      <p class="info-screen-header"> ${pickText("infoScreen", "header")}</p>
      <p>
      ${pickText("infoScreen", "game")}
      </p>
      ${!mobileOrNot()
        ? `<p>
        ${pickText("infoScreen", "Desktop")}
          </p>`
        : `<p>
        ${pickText("infoScreen", "Mobile")}
          </p>`}

      <p>
      ${pickText("infoScreen", "feedback")}
      </p>
      <p> ${pickText("infoScreen", "creditsHeader")}</p>
      <ul>
        <li>Konsta Hölttä</li
        <li>Tapio Kantele</li>
        <li>Anna-Leena Lappalainen</li>
        <li>Mikko Lehtola</li>
        <li>Raili Löyttyniemi</li>
        <li>Eve Mantu</li>
        <li>Lauri Niinimäki</li>
        <li>Antti Saarenpää</li>
        <li>Nicolina Zilliacus-Korsström</li>
      </ul>
      <div class="info-images">
        <img
          src="${window.pakopeliPublicAssetUrl}img/yle-valkoinen.png"
          style="width: 60px"
        />
        <img src="${window.pakopeliPublicAssetUrl}img/oppiminen.png" />
      </div>
      <div class="other-credits">
        <p>
          3d-models Sketchfab.com (CC BY 4.0): Hassan, Shedmon, Artem Goyko,
          Daniyal Malik, Charles Cla, vUv, Lucas Garnier, Too Many Demons,
          Cooper, Somnit, John Dinnwiddie, rorototo, Gunnar Correa, al0sral0,
          Aki Kato, Shedmon, vracolacus, golddog, Elizion, NeverSleep,
          Macropolo, Fabian van Dorst, Tarndor, valentin321, Ministephen, Paul
          Subert, Traian Dumbrava, Yannick Weber, CakeMachine, Man3gga, Rodrigo
          Villani, SplashKid, Berk Gedik, Yevheniia, Idalgame
        </p>
        <p>Sound effects: Epidemic Sound</p>
        <p></p>
        <p style="display: none; font-family: 'Roboto condensed bold'" @click=${() => puzzleWindow.exit()}>${pickText("infoScreen", "closeWindow")}</p>
      </div>
    </div>
<div>
    `);

  render(markup, puzzleWindow.element);
  document.body.classList.add("hideImages")
  const scroller = iOSallowScroll(".info-container");
};
